import styled from 'astroturf/react';
import { EiqButton } from 'eiq-storybook';

const LinkButton = styled(EiqButton)`
`;

const Title = styled('span')`
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: var(--ph-heading-three);
  font-family: var(--ph-font-family-lato-regular);
`;

const Text = styled('div')`
  font-size: var(--ph-text-sm);
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: var(--ph-gray-500);
  margin: 10px 0;
`;

const EntityUsages = styled('div')`
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
  border: solid 1px var(--ph-gray-100);
  outline: none;
  background-color: var(--white);
  padding-left: 5px;
  padding-right: 5px;
  max-height: 150px;
  min-height: 30px;
  overflow-y: auto;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: var(--black);
  font-size: var(--ph-text-sm);
  margin-bottom: 20px;

  div {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
`;

const SubmitButton = styled(EiqButton)`
  background-color: var(--cyan-green) !important;

  &:hover {
    background-color: transparent !important;
    }
`;

const SelectBoxWrapper = styled('div')`
  label {
    background-color: transparent;
    display: block;
    border: 0;
    padding: 0;
    margin: 0;

    div[class*='SelectBoxLabel'] {
      padding: 0;
      margin-bottom: 6px;
      border-right: 0;
    }

    div[class*='SelectBoxContainer'] {
      border: solid 1px #e5e6e5;
    }
  }
`;

export default {
  LinkButton,
  Title,
  Text,
  EntityUsages,
  SubmitButton,
  SelectBoxWrapper,
};
